import React, { FC, useState } from 'react';
import { Popup }               from 'semantic-ui-react';
import { Cell, Grid }          from "styled-css-grid";
import _                       from 'underscore';

import { ResourcesService }                     from '../../../../services';
import { CorvalProjectActivity }                from '../../../../types';
import { useProjectTermDictionary }             from '../../../../hooks';
import { CurrencyValue, ModifiedCurrencyValue } from '../../../components/display/CurrencyValue';
import { FinePrintMessage }                     from '../../../components/util/messaging/FinePrintMessage';

interface Props {
	projectActivity: CorvalProjectActivity
}

const defaultProps: Props = {
	projectActivity: null,
}

const ProjectActivityDetailsOngingCost: FC<Props> = ( { projectActivity } ) => {
	
	let { getTerm } = useProjectTermDictionary();
	
	let [ ongoingCostMin, ongoingCostMax ]                     = ResourcesService.getTotalOngoingActivityCosts( projectActivity ),
	    [ calculatedOngoingCostMin, calculatedOngoingCostMax ] = ResourcesService.getTotalOngoingActivityCosts( projectActivity, false ),
	    ongoingCost                                            = ResourcesService.getCostValueFromCostData( [ ongoingCostMin, ongoingCostMax ] ),
	    calculatedOngoingCost                                  = ResourcesService.getCostValueFromCostData( [ calculatedOngoingCostMin, calculatedOngoingCostMax ] );
	
	return !ResourcesService.hasOngoingCostOverride( projectActivity )
	       ? <CurrencyValue value={ ongoingCost } emptyOnZero={ true } valueFormatting={ value => `${ value } / qtr` }/>
	       : <Popup
		       wide
		       position={ 'top right' }
		       className={ 'text-left' }
		       content={
			       <Grid columns={ `auto 1fr` } className={ 'text--sm' }>
				
				       {/* Header */ }
				       <Cell width={ 2 }>Modified { getTerm( 'BUDGET_COSTS.ONGOING_COSTS.LABEL' ) }</Cell>
				
				       {/* Notes */ }
				       { !_.isEmpty( projectActivity.ongoingCostOverrideNote ) &&
				       <Cell width={ 2 }>
					       <FinePrintMessage>{ projectActivity.ongoingCostOverrideNote }</FinePrintMessage>
				       </Cell> }
				
				       {/* Original Cost */ }
				       <Cell><strong>Corval calculated cost:</strong></Cell>
				       <Cell><CurrencyValue value={ calculatedOngoingCost } emptyOnZero={ false }/> / qtr</Cell>
			
			       </Grid> }
		       trigger={ (
			       <abbr className="cursor--pointer" title={ '' }>
				       <ModifiedCurrencyValue value={ ongoingCost } emptyOnZero={ true }/> / qtr
			       </abbr>
		       ) }/>;
};

ProjectActivityDetailsOngingCost.defaultProps = defaultProps;

export { ProjectActivityDetailsOngingCost }
